{
  "filters": {
    "creationDate": {
      "label": "Fecha de incorporación",
      "formatter": {
        "input": "YYYY-MM-DD",
        "tag": "DD/MM/YYYY"
      },
      "periodSeparator": "al",
      "placeholder": "Seleccionar un período"
    },
    "searchByNameOrVersion": "Búsqueda por nombre o versión",
    "range": "Tipo",
    "status": "Estado"
  },
  "newFirmware": "Nuevo firmware",
  "noFirmware": "No hay ningún firmware disponible",
  "column": {
    "versionName": "Nombre de la versión",
    "type": "Tipo",
    "declination": "Gama",
    "version": "Versión",
    "buildDate": "Fecha de generación",
    "creationDate": "Fecha de incorporación",
    "dateFormat": "DD/MM/AAAA a HH:mm",
    "status": "Estado"
  },
  "actions": {
    "activate": {
      "label": "Activar el firmware",
      "description": "Se va activar el firmware {name}."
    },
    "deactivate": {
      "label": "Desactivar el firmware",
      "description": "Se ha desactivado el firmware {name}."
    },
    "delete": {
      "label": "Eliminar el firmware",
      "description": "Se va a eliminar el firmware {name}.",
      "descriptionEmbedded": "Actualmente se utiliza el firmware {name} en una campaña o una operación. Al eliminarlo se anularán estas operaciones."
    }
  },
  "status": {
    "ACTIVATED": "Activo",
    "DEACTIVATED": "Inactivo"
  },
  "section": {
    "informations": {
      "title": "Informaciones del firmware"
    },
    "compatibility": {
      "title": "Compatibilidad del firmware"
    },
    "complements": {
      "title": "Complementos"
    }
  },
  "validation": {
    "name": "El nombre del firmware es obligatorio",
    "version": "La versión del firmware es obligatoria"
  },
  "form": {
    "name": "Nombre de la versión",
    "description": "Descripción",
    "version": "Versión",
    "range": "Tipo",
    "declination": "Gama",
    "hardwareVersions": "Versiones de hardware",
    "firmwareVersions": "Versiones de firmware",
    "status": "Estado",
    "minimalCompatibleFirmwareVersion": "Versión mínima compatible del firmware"
  },
  "upload": {
    "title": "Seleccionar un archivo",
    "browse": "Examinar",
    "restrictionInformation": "El firmware depositado debe ser un archivo .ZIP y tener un tamaño inferior a 750 MB.",
    "validation": {
      "fileMandatory": "El archivo debe ser un .ZIP",
      "fileEmpty": "El archivo .ZIP no debe estar vacío",
      "fileSize": "El tamaño del archivo .ZIP debe ser inferior a 750 MB"
    }
  },
  "firmwareInfo": {
    "compatibility": {
      "title": "Compatibilidad",
      "description": "El firmware seleccionado tiene las siguientes dependencias:"
    },
    "equipmentTypeAttached": "Tipo de equipo conectado al firmware",
    "compatibleHardwareVersions": "Versiones de hardware compatibles",
    "compatibleFirmwareVersions": "Versiones de firmware compatibles"
  },
  "selected": "Firmware seleccionado:"
}
